import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';

/**
 * Hook to fetch product custom fields
 */
export const useProductCustomFields = (productId) => {
  const [customFields, setCustomFields] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!productId) {
      setCustomFields([]);
      setLoading(false);
      return;
    }

    const fetchCustomFields = async () => {
      try {
        setLoading(true);
        console.log('Fetching custom fields for product:', productId);

        const { data, error: fetchError } = await supabase
          .from('product_custom_fields')
          .select('*')
          .eq('product_id', productId)
          .order('created_at', { ascending: true });

        if (fetchError) {
          throw fetchError;
        }

        console.log('Custom fields fetched:', data);
        setCustomFields(data || []);
      } catch (err) {
        console.error('Error fetching custom fields:', err);
        setError(err.message);
        setCustomFields([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomFields();
  }, [productId]);

  return { customFields, loading, error };
};

